import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { getFrontendExperiment } from '@atlassian/search-experiment';

import { DisableDefinitionsMenu } from '../../v2/definitions/body/disable-menu/DisableDefinitionMenu';
import { DefinitionsDropdownMenu } from '../../v2/definitions/body/dropdown-menu/DefinitionsDropdownMenu';

import { ReadingAidsMenuButton } from './reading-aids-menu-button';
import { ReadingAidsOptionsWrapper } from './styled';

export const ReadingAidsOptions = (): React.JSX.Element => {
	const platformDisableOn = fg('kd_definitions_confluence_enable_platform');

	const { serveExperiment: serveDefinitionsUXExp } = getFrontendExperiment({
		abTestId: 'kd_definitions_ux_uplift_exp',
	});
	const serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');

	return (
		<ReadingAidsOptionsWrapper>
			{serveDefinitionUXUpdates ? (
				<DefinitionsDropdownMenu />
			) : platformDisableOn ? (
				<DisableDefinitionsMenu />
			) : (
				<ReadingAidsMenuButton />
			)}
		</ReadingAidsOptionsWrapper>
	);
};
